import { ScrollBtn, ScrollDot } from "./ScrollButton.styles";

const ScrollButton = ({ buttonRef }: any) => {
  return (
    <ScrollBtn ref={buttonRef}>
      <ScrollDot></ScrollDot>
    </ScrollBtn>
  );
};

export default ScrollButton;
